import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "item", "template"]

  add(event) {
    event.preventDefault()
    
    // Get the template content
    const template = this.templateTarget.innerHTML
    const time = new Date().getTime()
    const newTemplate = template.replace(/NEW_RECORD/g, time)
    
    // Insert the new fields before the add button
    this.itemsTarget.insertAdjacentHTML('beforeend', newTemplate)
  }

  remove(event) {
    event.preventDefault()
    
    const item = event.target.closest('[data-nested-form-target="item"]')
    const destroyInput = item.querySelector('input[name*="_destroy"]')
    
    if (destroyInput) {
      // Mark for destruction instead of removing from DOM
      destroyInput.value = "1"
      item.style.display = "none"
    } else {
      // For new records, just remove from DOM
      item.remove()
    }
  }
}